// Golf Elite platform subscription — client wrappers over the PLATFORM Stripe
// Cloud Functions (separate account from club entry-fee billing). The browser
// never holds a secret and never marks itself active.
import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from './firebase.js'

const fns = () => getFunctions(app, 'us-central1')

export async function startSubscriptionCheckout(priceId, clubName) {
  const { data } = await httpsCallable(fns(), 'createSubscriptionCheckout')({ priceId, clubName, origin: window.location.origin })
  if (!data?.url) throw new Error('Could not start checkout.')
  window.location.assign(data.url)
}
export async function openBillingPortal() {
  const { data } = await httpsCallable(fns(), 'createBillingPortalSession')({ origin: window.location.origin })
  if (!data?.url) throw new Error('Billing portal unavailable.')
  window.location.assign(data.url)
}
